import { ContentChild, Directive, HostListener, Input } from '@angular/core';
import { CxIconComponent } from './icon/cx-icon.component';

@Directive({
  selector: 'button.toggle-password[appPasswordVisibilityToggle]',
})
export class PasswordVisibilityToggleDirective {
  @Input() toggle = '';
  @ContentChild(CxIconComponent) icon?: CxIconComponent;

  @HostListener('click')
  togglePasswordVisibility(): void {
    const input = document.querySelector<HTMLInputElement>(this.toggle);
    if (!input) return;

    const revealPassword = input.type === 'password';
    input.type = revealPassword ? 'text' : 'password';
    if (this.icon) this.icon.name = revealPassword ? 'eye-off' : 'eye';
  }
}
